(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  // Décocher automatiquement l'assurance shipping AVANT de la masquer
  function uncheckInsurance() {
    // Chercher toutes les checkboxes d'assurance possibles
    const selectors = [
      '#tm_switch_btn',
      '.tm_switch_label[type="checkbox"]',
      'input[type="checkbox"][id*="insurance"]',
      'input[type="checkbox"][id*="captain"]',
      'input[type="checkbox"][class*="insurance"]',
      '.ship-insurance input[type="checkbox"]',
      '.tm_cart input[type="checkbox"]'
    ];
    
    selectors.forEach(selector => {
      const checkbox = document.querySelector(selector);
      if (checkbox && checkbox.checked) {
        console.log('🔧 Décochage de:', selector);
        checkbox.checked = false;
        
        // Déclencher les événements pour mettre à jour le prix
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        checkbox.dispatchEvent(new Event('click', { bubbles: true }));
        
        // Chercher et déclencher la fonction Captain Insurance si elle existe
        if (typeof captain_checkboxChange === 'function') {
          captain_checkboxChange(checkbox, new Event('change'));
        }
        
        console.log('✅ Assurance shipping décochée:', selector);
      }
    });
  }
  
  // Décocher dès que possible
  uncheckInsurance();
  
  document.addEventListener('DOMContentLoaded', function() {
    uncheckInsurance();
    
    // Vérifier régulièrement
    setInterval(uncheckInsurance, 500);
    
    // Observer les changements du DOM
    const observer = new MutationObserver(function() {
      setTimeout(uncheckInsurance, 100);
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  customElements.define(
    'prices-checkout',
    class PricesCheckout extends HTMLElement {
      constructor() {
        super();

        this.handleMutations = this.handleMutations.bind(this);
        this.updateComparePrice = this.updateComparePrice.bind(this);
      }

      connectedCallback() {
        this.priceElement = this.querySelector('.money');
        this.comparePriceElement = this.querySelector('s');

        const observerConfig = {
          characterData: true,
          childList: true,
          subtree: true,
        };

        this.observer = new MutationObserver(this.handleMutations);
        this.observer.observe(this.priceElement, observerConfig);

        this.updateComparePrice();
      }


      updateComparePrice() {
        const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
          ? window.themeVariables.settings.moneyWithCurrencyFormat
          : window.themeVariables.settings.moneyFormat;

        this.comparePriceElement.innerHTML = formatMoney(
          parseFloat(this.comparePriceElement.dataset.originalCompare),
          currencyFormat
        );
      }

      handleMutations(mutationsList) {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            this.updateComparePrice();
            this.observer.disconnect();
          }
        }
      }
    }
  );

  class giftWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.textarea = this.closest('cart-drawer').querySelector('textarea');

      this.querySelector('input').addEventListener('change', () => {
        if (this.querySelector('input').checked) {
          this.textarea.value += `${this.closest('line-item').dataset.title} : It's a gift\n`;
        } else {
          this.textarea.value = this.textarea.value.replace(
            `${this.closest('line-item').dataset.title} : It's a gift\n`,
            ''
          );
        }
      });
    }
  }
  customElements.define('gift-wrapper', giftWrapper);

  class UpsellVariants extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.formId = this.closest('.upsell-product').querySelector('.upsell-product__add-form input[name="id"]');

      this.querySelector('select.visually-hidden').addEventListener('change', () => {
        this.formId.value = this.querySelector('select').value;
      });
    }
  }
  customElements.define('upsell-variants', UpsellVariants);

  class UpsellProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      new window.ThemeFlickity(this, {
        cellAlign: 'left',
        contain: false,
        pageDots: false,
        width: 'calc(100% - 25px)',
        gap: 10,
        prevNextButtons: false,
        wrapAround: false,
      });
    }
  }
  customElements.define('upsell-products', UpsellProducts);

  } catch(e) { console.error(e); }
})();
})();
